import DOMPurify from 'dompurify';
import type { DirectiveBinding } from 'vue';

export const safeHtml = (el: HTMLElement, binding: DirectiveBinding) => {
  el.innerHTML = DOMPurify.sanitize(binding.value as string);
};
